import { useRef, useState } from 'react';
import {
    guardarLicenciaDeEmpleado,
    obtenerDocumentosPorEmpleado,
    eliminarDocumento,
    getDocumentoCabByEmpleadoYTipo,
    guardarDocumentosCab,
    anulaDocumentoCab,
    modificarDocumentosCab
} from '../../../services/empleado/empleadoDocumentoService';
import { formatToJava } from '../../../util/dateUtils';

const emptyLicencia = {
    id: null,
    categoria: '',
    numero: '',
    fechaEmision: null,
    fechaVencimiento: null
};

// Helper de fechas
const convertirFecha = (f) => {
    if (!f) return null;
    if (Array.isArray(f)) return new Date(f[0], f[1] - 1, f[2]);
    if (typeof f === 'object' && f.year) return new Date(f.year, f.monthValue - 1, f.dayOfMonth);
    if (typeof f === 'string') return new Date(f);
    return new Date(f);
};

export const useLicencia = ({ empleadoId, toast, configMap, listas }) => {
    // 1. Estados
    const [licencias, setLicencias] = useState([]);
    const [licenciaData, setLicenciaData] = useState(emptyLicencia);
    const [licenciaDialog, setLicenciaDialog] = useState(false); // Modal Formulario
    const [licenciaFile, setLicenciaFile] = useState([]);
    const [licenciaLoading, setLicenciaLoading] = useState(false);

    const [loading, setLoading] = useState(false);

    //const filesUploadRef = useRef(null)

    // 2. Carga de Licencias
    const recargarLicencias = async (id) => {
        if (!id) {
            setLicencias([]);
            return;
        }

        try {
            const docs = await obtenerDocumentosPorEmpleado(id);

            // A. Buscar ID de configuración
            const configLicencia = listas?.tiposOtrosDocs?.find(
                (d) => d.codigo === configMap.FORM_LICENCIA
            );
            let ID_LICENCIA = configLicencia ? configLicencia.configuracionDetId : null;

            // B. Fallback: Buscar por descripción si no hay configuración
            if (!ID_LICENCIA && docs.length > 0) {
                const posible = docs.find(
                    (d) => d.descripcion && d.descripcion.includes('Licencia')
                );
                if (posible) ID_LICENCIA = posible.tipoDocumentoId;
            }

            // C. Filtrar y Mapear
            if (ID_LICENCIA || docs.length > 0) {
                const misLicencias = docs.filter(
                    (d) =>
                        (ID_LICENCIA && d.tipoDocumentoId === ID_LICENCIA) ||
                        (d.descripcion && d.descripcion.includes('Licencia'))
                );

                setLicencias(
                    misLicencias.map((doc) => ({
                        id: doc.id,
                        categoria: doc.categoriaId, // ID para el Dropdown
                        numero: doc.referencia, // El backend manda el nro en 'referencia'
                        fechaEmision: convertirFecha(doc.fechaInicio),
                        fechaVencimiento: convertirFecha(doc.fechaFin),
                        archivoUrl: doc.url
                    }))
                );
            }
        } catch (e) {
            console.error('Error recargando licencias:', e);
        }
    };

    // 3. Acciones de Apertura
    const openNewLicencia = () => {
        setLicenciaData(emptyLicencia);
        setLicenciaFile(null);
        setLicenciaDialog(true);
    };

    const openEditLicencia = (rowData) => {
        setLicenciaData({ ...rowData });
        setLicenciaFile(null);
        setLicenciaDialog(true);
    };

    // Helper para inputs del formulario
    const onLicenciaChange = (val, name) => {
        setLicenciaData((prev) => ({ ...prev, [name]: val }));
    };

    // 4. Guardar
    const saveLicencia = async () => {
        if (loading) return;
        if (!empleadoId) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atención',
                detail: 'Guarde el empleado primero.'
            });
            return;
        }

        if (!licenciaData.categoriaId || !licenciaData.numero) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Categoría y Número son obligatorios.'
            });
            return;
        }

        // Validación de archivo solo para nuevos
        if (!licenciaData.id && !licenciaFile) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Debe adjuntar una imagen o documento.'
            });
            return;
        }

        const formatearFecha = (d) => (d && d.toISOString ? d.toISOString().split('T')[0] : null);

        const payload = {
            id: licenciaData.id,
            codigoTipoDocumento: configMap.FORM_LICENCIA,
            categoria_id: licenciaData.categoria,
            numero: licenciaData.numero,
            fecha_inicio: formatearFecha(licenciaData.fechaEmision),
            fecha_fin: formatearFecha(licenciaData.fechaVencimiento)
        };

        try {
            setLoading(true);
            await guardarLicenciaDeEmpleado(empleadoId, payload, licenciaFile);
            toast.current.show({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Licencia guardada correctamente'
            });

            setLicenciaDialog(false);
            setLicenciaData(emptyLicencia);
            setLicenciaFile(null);
            await recargarLicencias(empleadoId);
        } catch (error) {
            console.error(error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo guardar la licencia'
            });
        } finally {
            setLoading(false);
        }
    };

    // 5. Eliminar
    const deleteLicencia = async (rowData) => {
        if (!window.confirm(`¿Estás seguro de eliminar la licencia ${rowData.numero}?`)) return;

        try {
            await eliminarDocumento(rowData.id);
            //const data = await anulaDocumentoCab(rowData.id)
            toast.current.show({
                severity: 'success',
                summary: 'Eliminado',
                detail: 'Licencia eliminada.'
            });

            // Actualización optimista o recarga
            setLicencias((prev) => prev.filter((item) => item.id !== rowData.id));
        } catch (error) {
            console.error('Error eliminando licencia:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo eliminar.'
            });
        }
    };

    /// *************** codigo nuevo.
    const cargaLicencias = async (empleadoId) => {
        const CODE_TIPOREGISTRO_LICENCIA = 'NOM-0000-0015-0000';
        try {
            const data = await getDocumentoCabByEmpleadoYTipo(
                empleadoId,
                CODE_TIPOREGISTRO_LICENCIA
            );
            const lista = data.map((item) => ({
                id: item.documentoCabId,
                categoria: item.categoriaConfDet.configuracionDetId,
                numero: item.referenciaDetalle,
                fechaEmision: convertirFecha(item.fechaInicio),
                fechaVencimiento: convertirFecha(item.fechaFin),
                archivoUrl: ''
            }));
            setLicencias(lista);
        } catch (error) {
            console.error('Error al Obtener Licencias:', error);
        }
    };

    const guardaLicencia = async () => {
        if (!empleadoId) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atención',
                detail: 'Guarde el empleado primero.'
            });
            return;
        }

        if (!licenciaData.categoriaId || !licenciaData.numero) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Categoría y Número son obligatorios.'
            });
            return;
        }

        // Validación de archivo solo para nuevos
        if (!licenciaData.id && !licenciaFile) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Debe adjuntar una imagen o documento.'
            });
            return;
        }
        
        const CODE_TIPOREGISTRO_LICENCIA = 'NOM-0000-0015-0000';
        setLoading(true);
        setLicenciaLoading(true);
        try {
            const objGuardar = {
                entidadId: empleadoId,
                nombreEntidad: 'EMPLEADO',
                categoriaConfDetId: licenciaData.categoriaId,
                referenciaDetalle: licenciaData.numero,
                descripcion: `Licencia de Conducir`,
                fechaInicio: formatToJava(licenciaData.fechaEmision),
                fechaFin: formatToJava(licenciaData.fechaVencimiento),
                fechaEmision: '', 
                codigoTipoDocumento: CODE_TIPOREGISTRO_LICENCIA
            };
            if (licenciaData.id) {
                objGuardar['documentoCabId'] = licenciaData.id;
                const data = await modificarDocumentosCab(objGuardar, licenciaFile);
            } else {
                const data = await guardarDocumentosCab(objGuardar, licenciaFile);
            }
            toast.current.show({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Licencia guardada correctamente'
            });
            setLicenciaDialog(false);
            setLicenciaData(emptyLicencia);
            setLicenciaFile(null);
            await cargaLicencias(empleadoId);
        } catch (error) {
            console.error('Error al Guardar Licencias:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se han guardado las Licencias'
            });
        } finally {
            setLoading(false);
            setLicenciaLoading(false);
        }
    };
    /// ***************

    const anulaLicencia = async (rowData) => {
        if (!window.confirm(`¿Estás seguro de eliminar la licencia ${rowData.numero}?`)) return;

        try {
            const data = await anulaDocumentoCab(rowData.id);
            toast.current.show({
                severity: 'success',
                summary: 'Eliminado',
                detail: 'Licencia eliminada.'
            });

            // Actualización optimista o recarga
            setLicencias((prev) => prev.filter((item) => item.id !== rowData.id));
        } catch (error) {
            console.error('Error eliminando licencia:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo eliminar.'
            });
        }
    };

    return {
        licencias,
        licenciaData,
        setLicenciaData,
        licenciaDialog,
        setLicenciaDialog,
        licenciaFile,
        setLicenciaFile,
        recargarLicencias,
        openNewLicencia,
        openEditLicencia,
        saveLicencia,
        deleteLicencia,
        onLicenciaChange,
        setLicencias,
        loading,
        ///
        cargaLicencias,
        guardaLicencia,
        licenciaLoading,
        anulaLicencia
    };
};
